export default __webpack_public_path__ + "static/media/modulePregnancyMINIAPPS-fixed.25aa6d2c.mp4";